import { useCallback, useSyncExternalStore } from 'react'

/** Phones and small tablets — the width the app shell switches to the bottom nav at. */
export const MOBILE_MEDIA_QUERY = '(max-width: 768px)'

/**
 * Whether `query` matches, kept current as the viewport changes. False where matchMedia is
 * missing (SSR prerender, old test DOMs), so callers render their desktop layout there.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {}
    const list = window.matchMedia(query)
    if (typeof list.addEventListener === 'function') {
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    }
    list.addListener(onChange)
    return () => list.removeListener(onChange)
  }, [query])

  const getSnapshot = useCallback(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
    [query],
  )

  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
